import React from 'react';
import {Helmet} from "react-helmet";
import {ReactComponent as MobileChatIcon} from 'assets/img/mobileChatIcon.svg';
import styles from './MobileChatButton.module.scss';
import {openCrispChat} from 'gui/components/crispChat/CrispChat';

interface IMobileChatButtonProps {
  className?: string;
}

const MobileChatButton = (props: IMobileChatButtonProps) => {
  return (<>
      <Helmet>
        <style>{`
        @media (max-width: 767px) {
        #crisp-chatbox .cc-unoo {
        display: none !important;
      }
      }
        `}
        </style>
      </Helmet>
      <MobileChatIcon className={`${styles.mobileChatIcon} ${props.className}`.trim()} onClick={openCrispChat}/>
    </>
  );
};
MobileChatButton.defaultProps = {
  className: '',
};
export default React.memo(MobileChatButton);
